import React, { Component } from 'react';

import { connect } from 'react-redux';
import { firebaseConnect, helpers } from 'react-redux-firebase';
const { isLoaded, dataToJS } = helpers;

import { openModal } from 'actions/modal';

import  StudentPanelListItem from './StudentPanelListItem';

import Input from 'components/Input';
import Button from 'components/Button';

import { keyedObjToArr, formatPrice } from '../../util';

class StudentPanelList extends Component {

	constructor(props) {
		super(props);

		let students = this.props.classroom.students || {};

		this.state = {
			student : {},
			students : students
		};
	}

	setStudentName (event) {
		let student = this.state.student;
		student.name = event.target.value;
		this.setState({
			student : student
		});
	}

	addStudent () {
		const { firebase } = this.props;
		let student = this.state.student;
		let students = this.state.students;

		if((Object.keys(students).length + 1) > this.props.classroom.studentCount) {
			return;
		}

		if(!student.name) {
			return;
		}

		for(var s in students){
			if(students[s].name === student.name.trim()) {
                this.props.openModal(null, {
                    message: 'This name already exists in this classroom, please use a different name',
                    title: 'Duplicate student',
					ackOnly : true
                });
                return;
            }
		}

        this.setState({
        	student : {}
        });

		firebase.push(`/classrooms/${this.props.classroom.id}/students`, student).then( (response)=> {
			students[response.key] = student;
			this.props.updateClassroomStudents(students);
			this.setState({
				students:students
			});
		});

	}

	deleteStudent (student) {

		this.props.openModal(null, {
			message : 'Are you sure you want to delete ' + student.name + '?',
			title : 'Delete Student',
			onClose : (result) => {
				if(result === true) {
					const { firebase } = this.props;
					let students = this.state.students;
					firebase.remove(`/classrooms/${this.props.classroom.id}/students/${student.id}`).then( (response)=> {
						delete students[student.id];
						this.props.updateClassroomStudents(students);
						this.setState({
							students : students
						});
					});
				}
			}
		});
		this.setState({
			student : {}
		});
	}

	render () {

		let students = this.state.students ? keyedObjToArr(this.state.students) : [];
        students.sort(function(a, b) {
            return a.name > b.name;
        });

		return (<div>
			<div className="ui-list tight">
				<div className="header-container">
					<div className="list-row header" key="header">
						<div className="list-cell"><span className="data">Name</span></div>
						<div className="list-cell"><span className="data">Lesson</span></div>
						<div className="list-cell"><span className="data">Activity</span></div>
						<div className="list-cell qty no-grow align-right"><span className="data"></span></div>
					</div>
				</div>

				{students.map( (student, index) => {
					return (<StudentPanelListItem
						key={student.id}
						student={student}
						classroom={this.props.classroom}
						deleteStudent={this.deleteStudent.bind(this, student)}
						/>);
				})}
			</div>
			<div className="flex-grid tight">
					<div className="col grow">
						<Input
							placeholder="Student Name"
							onChange={this.setStudentName.bind(this)}
							value={this.state.student.name}
						/>
					</div>
					<div className="col no-grow">
						<Button
							label="Create Student"
							disabled={!this.state.student.name || (Object.keys(students).length + 1) > this.props.classroom.studentCount}
							onClick={this.addStudent.bind(this)}
						/>
					</div>
				</div>

		</div>);
	}
}


const mapDispatchToProps = (dispatch) => {
	return {
		openModal : (modal, props) => { dispatch(openModal(modal, props)); }
	};
};


const fbWrappedComponent = firebaseConnect()(StudentPanelList);
export default connect(null, mapDispatchToProps)(fbWrappedComponent);




// WEBPACK FOOTER //
// ./js/components/StudentPanelList/StudentPanelList.js